<template>
  <o-form-wrapper v-model="item" :server-errors="_se" :v="$v.item" :schema="schema" :form-state="formState">
    <o-widget-wrapper :schema="schema" name="name" :validators="$v.item" :server-errors="_se" :form-state="formState">
      <o-text-field v-model="item.name" :form-state="formState" name="name" :validators="$v.item" :server-errors="_se"
        v-bind="schema.fields.name"></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper :schema="schema" name="type" :validators="$v.item" :server-errors="_se" :form-state="formState">
      <o-select v-model="item.type" :items="codeActivityTypeItems" text-field="description" value-field="id"
        sort-field="description" :form-state="formState" name="type" :validators="$v.item" :server-errors="_se"
        v-bind="schema.fields.type" store-name="CodeActivityType" @input="changeType">
      </o-select>
    </o-widget-wrapper>
    <o-widget-wrapper :schema="schema" name="params" :validators="$v.item" :server-errors="_se" :form-state="formState">
      <b-container fluid="xs" class="my-4">
        <b-row>
          <b-col class="text-right pr-0">Params</b-col>
          <b-col cols="10">
            <template v-if="!item.type">
              <p class="text-italic text-600">Select type</p>
            </template>

          </b-col>
        </b-row>
        <b-row class="mb-4" v-if="item.type == 2">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-form-input v-if="item.type == 2" v-model="item.params.url" type="text" placeholder="url"
              @input="validateForm"></b-form-input>
          </b-col>
        </b-row>
        <b-row v-if="item.type == 2">
          <b-col class="text-right pr-0">Add header</b-col>
          <b-col cols="10" >
            <b-button class="mb-4" @click="addHeaders()" variant="primary">+</b-button>
          </b-col>
        </b-row>
        <b-row :key="index" v-for="(form, index) in getHeaders" v-if="item.type == 2">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-row>
              <b-col cols="10">
                <div :key="index">
                  <b-form-input v-model="item.params.headers[index]" type="text" placeholder="headers" @input="validateForm">
                  </b-form-input>
                </div>
              </b-col>
              <b-col >
                <b-button @click="removeHeaders(form, index)" variant="danger">-</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row  v-if="item.type == 2">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-form-checkbox class="mt-4" v-model="item.params.send_token" placeholder="send_token" @input="validateForm">
              send token</b-form-checkbox>
          </b-col>
        </b-row>

        <b-row v-if="item.type == 3">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-form-input v-model="item.params.to_address" type="text" placeholder="to address" @input="validateForm">
            </b-form-input>
          </b-col>
        </b-row>
        <b-row v-if="item.type == 3">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-form-input v-model="item.params.subject" type="text" placeholder="subject" @input="validateForm">
            </b-form-input>
          </b-col>
        </b-row>

        <b-row v-if="item.type == 3">
          <b-col class="text-right pr-0">&nbsp;</b-col>
          <b-col cols="10">
            <b-form-textarea v-model="item.params.body" type="text" placeholder="body" @input="validateForm">
            </b-form-textarea>
          </b-col>
        </b-row>

        <!-- for send email -->

      </b-container>

      <!-- <o-text-field
        v-if="item.type == 2"
        v-model="item.params.timeout"
        :form-state="formState"
        name="params"
        step="1"
        type="number"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.params"
      ></o-text-field> -->
    </o-widget-wrapper>

    <o-widget-wrapper :schema="schema" name="description" :validators="$v.item" :server-errors="_se"
      :form-state="formState">
      <o-textarea v-model="item.description" :form-state="formState" name="description" :validators="$v.item"
        :server-errors="_se" v-bind="schema.fields.description"></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper :schema="schema" name="roles" :validators="$v.item" :server-errors="_se" :form-state="formState">
      <o-multi-checkbox :form-state="formState" :items="itemRolesId" :server-errors="_se" :validators="$v.item"
        name="roles" sort-field="description" text-field="description" v-bind="schema.fields.roles" v-model="item.roles"
        value-field="id"></o-multi-checkbox>
      <div class="form-row">
        <div class="col-lg-2 col-3 bv-no-focus-ring col-form-label text-right"></div>
        <div class="col">
          <template v-if="checkItemRoleId.length > 0" class="container">
            <p class="text-italic text-600">Update to see all User Roles</p>
          </template>
        </div>
      </div>
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OTextarea from "../../../../vue-ocom/components/forms/fields/OTextarea";
import OMultiCheckbox from "../../../../vue-ocom/components/forms/fields/OMultiCheckbox.vue";

import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";

import { default as CodeActivityTypeForm } from "../../code_activity_type/components/ItemForm";
// import { default as ActivityUserRoleFormCards } from '../../activity_user_role/components/ItemFormCards';

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ProcessActivity"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OMultiCheckbox,
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextarea,

    CodeActivityTypeForm,
    //ActivityUserRoleFormCards,
  },
  props: {
    itemRoles: { type: Array, default: () => [] },
    codeActivityTypeItems: { type: Array, default: () => [] },
    item: { type: Object, default: () => { } },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    formHeaders: [],
    schemaModel: cleanUpModel(schema.ProcessActivity, {}),
  }),
  methods: {
    removeHeaders(form, index){
      this.formHeaders.splice(index, 1);
      this.item.params.headers.splice(index, 1);
    },
    addHeaders() {
      this.formHeaders.push("")
      if (!this.item.params.headers) {
          this.item.params.headers = []
        }
      this.item.params.headers.push("");
    },
    changeType(e) {
      this.item.params = {};
      if (e == 2) {
        this.formHeaders.push("")
        this.item.params.url = ""
        this.item.params.send_token = false
        if (!this.item.params.headers) {
          this.item.params.headers = []
        }
        this.item.params.headers.push("");
      } else {
        this.item.params.to_address = ""
        this.item.params.subject = ""
        this.item.params.body = ""
      }
      
    },
    validateForm() {
      if (this.formState) this.formState.dirty = true;
    },
  },
  computed: {
    getHeaders(){
      if (this.item.params.headers && this.item.params.headers.length > 0 && this.formHeaders.length <=0) {
        this.item.params.headers.map((header) =>{
          this.formHeaders.push("")
        })
      }

      return this.formHeaders;
    },
    itemRolesId() {
      const result = this.itemRoles.filter(
        (i) => i.id != null || i.id != undefined || i.id
      );
      return result;
    },
    checkItemRoleId() {
      const result = this.itemRoles.filter(
        (i) => i.id == null || i.id == undefined || !i.id
      );
      return result;
    },
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {
  },
  created() { },
};
</script>
<style scoped>
.text-italic {
  font-style: italic;
}

.text-600 {
  font-weight: 600;
}
</style>